import { Injector, NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { FormioModule } from 'angular-formio';
import { FormbuilderEmbedComponent } from 'src/app/formioembed/formbuilder-embed/formbuilder-embed.component';
import { FormbuilderEmbedBaseComponent } from 'src/app/formioembed/formbuilder-embed-base/formbuilder-embed-base.component';
import { FormioembedRoutingModule } from 'src/app/formioembed/formioembed-routing.module';
import { registerCustomForms } from '../formiobuilder/components/custom-builder-components/custom-forms.formio';
import { FormsModule } from '@angular/forms';
import { SignaturePadModule } from 'angular2-signaturepad';
import { PaymentConfirmActionComponent } from 'src/app/formioembed/payment-confirm-action/payment-confirm-action.component';
import { CustomFormsModule } from 'src/app/formiobuilder/components/custom-builder-components/custom-forms.module';
import {
  CjButtonModule,
} from '@cashjar-dev/ui';

@NgModule({
  declarations: [
    FormbuilderEmbedComponent,
    FormbuilderEmbedBaseComponent,
    PaymentConfirmActionComponent,
  ],
  providers: [DatePipe, CurrencyPipe],
  imports: [
    CommonModule,
    FormioembedRoutingModule,
    FormioModule,
    FormsModule,
    SignaturePadModule,
    CustomFormsModule,
    CjButtonModule
  ],
})
export class FormioembedModule {
  constructor(injector: Injector) {
    registerCustomForms(injector);
  }
}
